import React from "react";
import PropTypes from "prop-types";
import Carousel from "react-slick";
import withStyles from "@material-ui/core/styles/withStyles";

import sponsors from "../../../config/sponsors";
import { shape } from "../../../theme/brand";

// Unlinked from `material-kit-pro-react`: brand-styled react-slick carousel driven
// by the shared sponsors list (dropped template `Grid`/`Card`/`carouselStyle`).
// Logos sit on light panels so they stay legible over the dark footer.
const styles = {
  wrapper: {
    "& .slick-dots": {
      display: "none"
    }
  },
  slide: {
    padding: "8px"
  },
  panel: {
    backgroundColor: "#fff",
    borderRadius: shape.borderRadius,
    width: "150px",
    height: "150px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "18px",
    boxSizing: "border-box"
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%"
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
  }
};

function SponsorsCarouselSection({ classes }) {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true
  };

  return (
    <div className={classes.wrapper}>
      <Carousel {...settings}>
        {sponsors.map(sponsor => {
          const logo = (
            <img
              className={classes.logo}
              src={sponsor.logo}
              alt={sponsor.name}
              title={sponsor.name}
            />
          );
          return (
            <div key={sponsor.name} className={classes.slide}>
              <div className={classes.panel}>
                {sponsor.url ? (
                  <a
                    className={classes.link}
                    href={sponsor.url}
                    target="_blank"
                    rel="external nofollow noopener noreferrer"
                  >
                    {logo}
                  </a>
                ) : (
                  logo
                )}
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

SponsorsCarouselSection.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SponsorsCarouselSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SponsorsCarouselSection.jsx